import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LOGIN_BACKGROUND_IMG } from './utils/apiRoutes';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

const theme = createMuiTheme({
  palette: {
    primary: blue,
  },
  typography: {
    useNextVariants: true,
  },
});

class App extends Component {
  renderStyles() {
    const backgroundImage = `${LOGIN_BACKGROUND_IMG}`;

    const bgUrl =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '') +
      backgroundImage;
    const styles = {
      marginRight: '0px',
      marginTop: '0px',
      marginLeft: '0px',
      width: '100%',
      height: '100%',
      backgroundColor: '#344560',
      backgroundImage: 'url(' + bgUrl + ')',
      WebkitBackgroundSize: 'cover',
      MozBackgroundSize: 'cover',
      OBackgroundSize: 'cover',
      backgroundSize: 'cover',
    };

    return styles;
  }

  render() {
    const main = this.renderStyles();
    
    return (
      <MuiThemeProvider theme={theme}>
        <div className="row center-xs middle-xs" style={main}>
          {this.props.children}
        </div>
      </MuiThemeProvider>
    );
  }
}

App.propTypes = {
  children: PropTypes.object,
};

export default connect()(App);
